/**
 * Module containing constants and configuration for the project, such as name,
 * location where the system will be used, and locale.
 *
 * @module constants
 */

/**
 * @type Object
 * @exports
 */
export default {
  name: 'Sugar Nanny',
  startYear: 2018,
  defaultLocale: 'en',
  license: 'rights',
  google: {
    picker: {
      developerKey: 'AIzaSyDlXMs635g20MdLuEkC4M7nU5LaRyevb4c',
      clientId: '811812278121-h8mcu3cq02mma0u02vvrkio82rpnb6g4.apps.googleusercontent.com',
      scope: 'https://www.googleapis.com/auth/drive.readonly',
    },
  },
};



// WEBPACK FOOTER //
// ./src/constants.js